export const ActionType = {
  FONT_SIZE: 'FONT_SIZE',
  FONT_FAMILY: 'FONT_FAMILY',
  FONT_COLOR: 'FONT_COLOR',
  FONT_STYLE: 'FONT_STYLE',
  SHOW_TITLE: 'SHOW_TITLE',
  OPACITY: 'OPACITY',
  LINE_TYPE: 'LINE_TYPE'
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/ui/actionType.js